import React from 'react';
import { Box } from '@mui/system';
import { ErrorMessage } from './styles';
import { ReactComponent as InformationIcon } from 'images/components/information.svg';

export const ErrorWrapper = (props) => {
  const { children, manualMessage, fitContent, ...rest } = props;
  let message = props.message ?? 'This field is required';
  if (children?.props?.hasErrors?.type === 'custom') {
    message = children.props.hasErrors.message;
  }

  return (
    <Box
      {...rest} maxWidth={fitContent ? 'fit-content' : 'none'} data-testid='mock-error-wrapper'>
      {children}
      {children?.props?.hasErrors && (
        <ErrorMessage>
          <InformationIcon />
          {message}
        </ErrorMessage>
      )}
    </Box>
  );
};
